import { render, staticRenderFns } from "./vendorDetail.vue?vue&type=template&id=56987e74&scoped=true"
import script from "./vendorDetail.vue?vue&type=script&lang=js"
export * from "./vendorDetail.vue?vue&type=script&lang=js"
import style0 from "./vendorDetail.vue?vue&type=style&index=0&id=56987e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56987e74",
  null
  
)

export default component.exports